import { FC } from 'react';

import { AboutUsSubpageFactsFragment_PublisherAboutUsFacts_Fragment } from '../../graphql/fragment/about-us-subpage-facts-fragment.gql-types';

import { Facts } from './facts';
import getCommonFactsItem from './get-common-facts-item';

type FactsPublisherProps = {
  facts: AboutUsSubpageFactsFragment_PublisherAboutUsFacts_Fragment;
};
export const FactsPublisher: FC<FactsPublisherProps> = ({ facts }) => {
  const items: any[] = [];
  const categories: string[] = [];

  if (facts.foundingYear) {
    items.push(getCommonFactsItem('foundingYear', facts.foundingYear));
  }

  return (
    <Facts
      headlineKey="EP_COMPANY_SUMMARY"
      items={items}
      categoriesHeadlineKey="EP_COMPANY_INDUSTRY"
      categories={categories}
      facts={facts}
    />
  );
};
